import styled from 'styled-components'
import HeaderBGMobile from '../../assets/images/cti-darki-force/cti-header-mobile.png';
import {SiteColors} from '../../config/site-colors';



const DesktopMarginBottom = "70px";


export const Wrapper = styled.div`
    * {
        font-family: Helvetica;
    }

    .container-fluid {
        padding-inline: 5%;
    }

    h1 {
        font-weight: 800;
    }

    h2 {
        @media screen and (max-width: 768px) {
            line-height: 35px !important;
        }
    }

    .add-space-on-mobile {
        @media screen and (max-width: 768px) {
            margin-bottom: 50px;
        }
    }
`;
export const Header = {
    Container: styled.div`
        width: 100%;
        height: 100vh;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        color: ${SiteColors.white};

        @media screen and (max-width: 768px) {
            background-image: url(${HeaderBGMobile}) !important;
        }
    `,
    Meta: styled.div`
        position: absolute;
        top: 50%;
        transform: translateY(-50%);

        @media screen and (max-width: 768px) {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
        }

        br {
            display: none;
            @media screen and (max-width: 768px) {
                display: block;
            }
        }

        h1 {
            text-transform: uppercase;
            font-size: clamp(30px, 2.5vw, 45px);
        }

        p {
            font-size: clamp(25px, 2vw, 30px);
        }

        a {
            cursor: pointer;
            text-decoration: underline;
            color: ${SiteColors.green};
        }
    `
}

export const Intro = {
    Container: styled.div`
        position: relative;
        background: linear-gradient(to right, #f0f0f0 45%, #969696 91%);
        padding: 30px 0;

        @media screen and (max-width: 768px) {
            padding: 50px 0;
        }

        .img-holder {
            display: flex;
            justify-content: center;
        }

        img {
            @media screen and (max-width: 992px) {
                width: 350px;
            }
        }

        .row {
            @media screen and (max-width: 768px) {
                flex-direction: column-reverse;
            }
        }

        h1 {
            margin-bottom: 20px;
        }

        p {
            font-size: clamp(18px, 1.2vw, 30px);
            @media screen and (max-width: 768px) {
                margin-bottom: 30px;
            }
        }
    `,
}

export const Advantages = {
    Container: styled.div`
        padding: 70px 0;
        background: ${SiteColors.black};
        color: ${SiteColors.white};

        .img-overlapping {
            position: relative;
            width: 110%;
            box-shadow: 3px 3px 6px 0 black;
            @media screen and (max-width: 1024px) {
                width: 200%;
                box-shadow: none;
            }
            @media screen and (max-width: 768px) {
                width: 100%;
                box-shadow: none;
            }
        }
        .img-overlay {
            
        }

        .container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

        }

        h1 {
            text-transform: uppercase;
            margin-bottom: 70px;
            text-align: center;
            text-decoration: underline;
            text-underline-offset: 10px;
        }

        .row {
            margin-bottom: ${DesktopMarginBottom};
        }

        hr {
            margin: 0 0 ${DesktopMarginBottom} 0;
            width: 100%;
            background-color: ${SiteColors.white};
            border: none;
            height: 2px;
            opacity: 1;
        }
    `,
    ContentBlock: styled.div`
        width: 100%;

        h2 {
            margin-bottom: 20px;
            font-weight: 700;
            line-height: 50px;
        }

        p {
            font-size: 20px;
            margin-bottom: 0;
        }
    `,
}

export const FormSection = {
    Container: styled.div`
        padding: 50px 0;
        background: linear-gradient(to right, #f0f0f0 45%, #969696 91%);
    `,
    Card: styled.div`
        background-color: white;
        border-radius: 20px;
        width: ${props => props.width ?? '25vw'};
        padding: ${props => props.padding ?? '30px'};
        height: fit-content;
        box-sizing: border-box;
        color: black;
        font-family: "Helvetica", Arial, sans-serif;
        display: flex;
        flex-direction: ${props => props.flexDirection ?? 'column'};
        justify-content: space-between;
        margin-bottom: 70px;

        @media screen and (max-width: 768px) {
            width: 90vw;
            flex-direction: column;
            margin-bottom: 0;
        }

        .form-title {
            font-weight: 700;
            font-size: 50px;
            text-align: left;
        }

        .form-comment {
            text-align: left;
            margin-top: 20px;
            font-size: large;
        }

        .form-message {
            margin-top: 30px;
            text-align: left;
            font-size: 12px;
            color: #565656;
        }

        .form-button {
            float: right;
            color: white;
            background-color: #000000;
            padding: 10px;
            padding-inline: 40px;
            cursor: pointer;
            text-transform: capitalize;
            margin-top: 30px;
            width: fit-content;
            border-radius: 10px;
            font-size: small;
            margin-left: auto;
            font-weight: 600;
            margin-right: 0;
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
            transition: box-shadow 0.3s ease;
            border: none;

            @media screen and (max-width: 768px) {
                float: left;
            }

            :hover {
                opacity: 0.7;
            }

            :active {
                opacity: 1;
            }
        }

        .form-error {
            margin-top: 20px;
            color: red;
            text-align: left;
        }
    `,

}

